// extracted by mini-css-extract-plugin
module.exports = {"auto-saved-state":"AutoSavedState_auto-saved-state__3omoq"};